import { useState } from "react";
import "../PromotionalPage.scss";

function PromoPageSEOBlurb() {
  const [isExpanded, setIsExpanded] = useState(false); // default to false (collapsed)

  const toggleContent = () => {
    setIsExpanded(prevState => {
      const newState = !prevState;
      return newState;
    });
  };

  return (
    <section className="promo-SEO-container">
      <h1>
        3et: The Premier Sports Betting Site for Low Margins, Best Odds and High
        Limits.
      </h1>
      {/* when mobile add read more here? */}
      <p>
        Looking for the best online sportsbook to place your bets? Get the best
        odds, lowest margins and highest bet limits on NFL betting, NBA betting,
        MLB betting, NHL betting, and live soccer betting with 3et. We offer a
        premium sports betting experience with live odds, in-play betting,
        moneylines, point spreads, bet builders and parlays, over/under totals,
        and player props on all major leagues, including the NFL, NBA, NHL, MLB,
        NCAA football, NCAA basketball, MLS, English Premier League, UEFA
        Champions League, and the World Cup.
      </p>

      {/* Read More Button */}
      <div className="read-more-toggle">
        <div onClick={toggleContent}>
          {isExpanded ? "Read Less" : "Read More"}
        </div>
      </div>

      {/* Toggleable Content */}
      {isExpanded && (
        <div className="toggle-content">
          {/* All sections (Section 2 to Section 5) */}
          <h2>Why Choose 3et for Online Sports Betting?</h2>
          <p>
            Looking for the ultimate experience for online sports betting with
            the best odds, high limits, and low margins? 3et is the go-to
            platform for serious bettors who want to maximize their returns and
            win long-term.
          </p>
          {/* Section 2 */}
          <h2>The 3et Advantage: Best Odds, High Limits, and Low Margins</h2>
          <p>
            <strong>
              Low Margin = Best Odds = Value Betting = Long-Term Profits
            </strong>
          </p>
          <p>
            A sportsbook's margin is its built-in profit on every bet. Lower
            margins mean more value is passed on to the player by offering
            better odds, which can significantly impact your long-term returns.
          </p>
          <p>
            Let's take the Super Bowl Coin Toss market as an example. Heads or
            Tails has a 50% chance of winning, and the odds should be +100. But
            some sportsbooks are showing odds of -120 for heads or tails. These
            sportsbooks have added a 9% margin. They win more, and you win less.
          </p>
          <p>
            3et is a low-margin sportsbook. Our margins will be less than 3% and
            this means that we almost always offer industry-leading sports
            betting odds on a huge number of top-tier events. You can see this
            on Betstamp, Unabated, SpankOdds and other odds comparison websites.
          </p>
          <p>
            Placing bets on 3et means you are maximising the value of your bets,
            leading to long-term profits. This is what professional bettors do,
            and that's why they use 3et.
          </p>
          <h3>High Limits: Freedom to Bet Big and Win Big</h3>
          <p>
            For high-stakes bettors, 3et offers some of the highest betting
            limits in the industry. Whether you're placing large wagers on the
            NFL, NBA, or live soccer betting markets, 3et ensures you can bet
            big and win big.
          </p>

          {/* Section 3 */}
          <h2>Live Soccer Betting at 3et: Best Odds in Real-Time</h2>
          <p>
            <strong>Why Live Soccer Betting?</strong>
          </p>
          <p>
            Live soccer betting is one of the fastest-growing betting markets in
            the world. 3et offers dynamic odds in real-time, allowing you to
            capitalize on key in-game moments.
          </p>
          <p>
            If a team is down 1-0 at halftime but dominating possession, their
            live odds might be undervalued, presenting a great opportunity.
          </p>
          <h3>Live Betting Strategies for Soccer</h3>
          <ul>
            <li>
              Betting on the next goal - If a team is applying heavy pressure,
              their live odds may still offer value.
            </li>
            <li>
              Second-half comebacks - Teams with strong second-half performances
              often present underrated live odds.
            </li>
            <li>
              Over/Under Goals Market - Adjusting bets based on game tempo and
              shot statistics can provide great value.
            </li>
          </ul>

          {/* Section 4 */}
          <h2>North American Sports Betting: NFL, NBA, and More</h2>
          <p>
            <strong>NFL Betting with the Best Odds and High Limits</strong>
          </p>
          <p>
            The NFL is North America's most popular sports betting market, and
            3et offers the best odds and high betting limits on point spreads,
            moneylines, and totals.
          </p>
          <p>
            <strong>
              Basketball Betting: Low Margins, Best Odds, and Big Wins
            </strong>
          </p>
          <p>
            Basketball betting is growing rapidly around the globe. 3et's NBA
            odds and NCAAB odds provide some of the best value in the industry
            with low margins and high limits.
          </p>
          <p>
            Fancy Luka Doncic to have an MVP kind of night? Combine his player
            prop markets into an NBA Same Game Parlay and turn his triple-double
            into a winning bet.
          </p>
          <p>
            <strong>NHL Betting: Low Margins, Best Odds, and Big Wins</strong>
          </p>
          <p>
            NHL betting provides non-stop action. Our NHL odds give you the edge
            you need to win long-term with your Ice Hockey betting.
          </p>

          {/* Section 5 */}
          <h2>Getting Started with 3et</h2>
          <p>
            <strong>Sign Up</strong>
          </p>
          <p>
            Visit 3et's website, click “Register”, and create an account in just
            a few minutes.
          </p>
          <p>
            <strong>Deposit</strong>
          </p>
          <p>
            Choose from secure payment methods, including Visa, Mastercard,
            Interac, Bank Transfers, Bitcoin, Tether and Ethereum.
          </p>
          <p>
            <strong>Place Your Bets</strong>
          </p>
          <p>
            Find your preferred sports betting market or live soccer match and
            place your bets with confidence.
          </p>

          <h2>Why 3et is the Best for Sports Betting and Live Soccer?</h2>
          <ul>
            <li>Best odds for maximized returns</li>
            <li>High betting limits for serious bettors</li>
            <li>Low margins to increase profitability</li>
            <li>Live betting markets for real-time soccer action</li>
            <li>Fast withdrawals within 24 hours</li>
          </ul>

          <p>
            Whether you're betting on the{" "}
            <strong>
              Super Bowl, NBA Finals, Stanley Cup Playoffs, World Series, March
              Madness, or international soccer tournaments
            </strong>
            , we have you covered with{" "}
            <strong>competitive odds and fast payouts.</strong> Sign up with 3et
            today and take your sports betting experience to the next level!
          </p>
        </div>
      )}
    </section>
  );
}

export default PromoPageSEOBlurb;
